module.exports = __webpack_public_path__ + "img/52114113_L.ac9c7ddb.png";